/* Age check pop-up (Age Checker Plus app) in the Barrel Station design.
   The app still decides who is 21+, and it redraws parts of the pop-up itself, so this script never moves
   or rewrites the app's own elements. It only:
   - swaps in the Barrel Station logo (black version, from Shopify Files)
   - adds its own heading and legal line, and hides the app's wording (CSS hides it; aria-hidden for screen readers)
   - adds empty "MM / DD / YYYY" choices so no birth date is preset, and names each field for screen readers
   - asks for all three date fields before the app checks the age
   - renames the button
   Field order (month, day, year) and the field labels are done in bs-agegate.css. */
(function () {
  if (window.bsAgeGate) return;
  window.bsAgeGate = true;

  var LOGO = 'https://cdn.shopify.com/s/files/1/0623/4524/9010/files/Black_logo_-_no_background.png?v=1643060363&width=480';
  var BUTTON = 'Enter Barrel Station';
  var FIELDS = { month: ['Month', 'MM', 'bday-month'], day: ['Day', 'DD', 'bday-day'], year: ['Year', 'YYYY', 'bday-year'] };

  function markEmpty(select) {
    select.classList.toggle('bs-agp-empty', select.value === '');
    if (select.value !== '') {
      select.classList.remove('bs-agp-invalid');
      select.removeAttribute('aria-invalid');
    }
  }

  function enhance(wrapper) {
    var row = wrapper.querySelector('.agp__row');
    var inner = wrapper.querySelector('.agp__rowInner');
    if (!row || !inner) return;

    var logo = wrapper.querySelector('img.agp__logo');
    if (logo && logo.getAttribute('src') !== LOGO) {
      logo.src = LOGO;
      logo.alt = 'Barrel Station';
      logo.width = 480;
      logo.height = 169;
    }

    var message = wrapper.querySelector('.agp__message');
    if (message) {
      message.classList.add('bs-agp-hidden');
      message.setAttribute('aria-hidden', 'true');
    }
    if (!wrapper.querySelector('.bs-agp-head')) {
      var head = document.createElement('div');
      head.className = 'bs-agp-head';
      head.innerHTML = '<p class="bs-agp-eyebrow">21+ only</p>' +
        '<h2 class="bs-agp-title" id="bs-agp-title">Are you 21 or older?</h2>' +
        '<p class="bs-agp-sub">Enter your date of birth to continue.</p>';
      var logoBox = wrapper.querySelector('.agp__logoContainer');
      if (logoBox) logoBox.insertAdjacentElement('afterend', head);
      else inner.insertBefore(head, inner.firstChild);
      row.setAttribute('role', 'dialog');
      row.setAttribute('aria-modal', 'true');
      row.setAttribute('aria-labelledby', 'bs-agp-title');
    }

    Object.keys(FIELDS).forEach(function (id) {
      var select = wrapper.querySelector('select#' + id);
      if (!select) return;
      var f = FIELDS[id];
      select.setAttribute('aria-label', f[0]);
      select.setAttribute('autocomplete', f[2]);
      if (!select.dataset.bs) {
        select.dataset.bs = '1';
        if (!select.querySelector('option[value=""]')) {
          var opt = document.createElement('option');
          opt.value = '';
          opt.textContent = f[1];
          opt.disabled = true;
          select.insertBefore(opt, select.firstChild);
          select.value = '';
        }
        select.addEventListener('change', function () {
          markEmpty(select);
          var err = wrapper.querySelector('.bs-agp-errmsg');
          if (err && !wrapper.querySelector('select.bs-agp-invalid')) err.hidden = true;
          /* The app redraws after each choice and puts its own button text back */
          setTimeout(function () { enhance(wrapper); }, 0);
          setTimeout(function () { enhance(wrapper); }, 80);
        });
      }
      markEmpty(select);
    });

    var dates = wrapper.querySelector('.agp__birthdayType__dateContainer');
    if (dates && !wrapper.querySelector('.bs-agp-errmsg')) {
      var err = document.createElement('p');
      err.className = 'bs-agp-errmsg';
      err.id = 'bs-agp-err';
      err.setAttribute('role', 'alert');
      err.hidden = true;
      err.textContent = 'Choose your month, day and year of birth.';
      dates.insertAdjacentElement('afterend', err);
    }

    var button = wrapper.querySelector('.agp__button');
    if (button && button.tagName === 'INPUT' && button.value !== BUTTON) button.value = BUTTON;

    var disclaimer = wrapper.querySelector('.agp__disclaimer');
    if (disclaimer) {
      disclaimer.classList.add('bs-agp-hidden');
      disclaimer.setAttribute('aria-hidden', 'true');
      if (!wrapper.querySelector('.bs-agp-legal')) {
        var legal = document.createElement('p');
        legal.className = 'bs-agp-legal';
        legal.innerHTML = 'By entering, you agree to our <a href="/policies/terms-of-service">Terms of Service</a> and <a href="/policies/privacy-policy">Privacy Policy</a>. Please enjoy responsibly.';
        disclaimer.insertAdjacentElement('afterend', legal);
      }
    }

    if (!row.dataset.bsAgp) {
      row.dataset.bsAgp = '1';
      var first = wrapper.querySelector('select#month');
      if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) {} }, 60);
    }
  }

  /* Block the app's check until all three fields are chosen */
  function guard(e) {
    var wrapper = e.target.closest && e.target.closest('.agp__wrapper');
    if (!wrapper) return;
    if (e.type === 'click' && !e.target.closest('.agp__button')) return;
    var empty = [];
    wrapper.querySelectorAll('.agp__birthdayType__dateContainer select').forEach(function (s) {
      if (s.value === '') empty.push(s);
    });
    if (!empty.length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    empty.forEach(function (s) {
      s.classList.add('bs-agp-invalid');
      s.setAttribute('aria-invalid', 'true');
      s.setAttribute('aria-describedby', 'bs-agp-err');
    });
    var err = wrapper.querySelector('.bs-agp-errmsg');
    if (err) err.hidden = false;
    try { empty[0].focus(); } catch (er) {}
  }
  window.addEventListener('click', guard, true);
  window.addEventListener('submit', guard, true);

  var watched = null;
  var observer = new MutationObserver(check);
  function check() {
    var w = watched && document.contains(watched) ? watched : document.querySelector('.agp__wrapper');
    if (!w) {
      if (watched) {
        watched = null;
        observer.disconnect();
        observer.observe(document.body, { childList: true, subtree: true });
      }
      return;
    }
    enhance(w);
    if (w !== watched) {
      /* Once the pop-up is found, only watch it (the app redraws parts of it) and its parent (it may be removed) */
      watched = w;
      observer.disconnect();
      observer.observe(w, { childList: true, subtree: true });
      if (w.parentNode) observer.observe(w.parentNode, { childList: true });
    }
  }
  function start() {
    observer.observe(document.body, { childList: true, subtree: true });
    check();
  }
  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
